<template>
  <footer class="fixed-bottom container-width">
    <div class="container">
      <slot />
    </div>
  </footer>
</template>